export enum PartStatus {
  OE_Certified = 'OE Certified',
  SKF_Verified = 'SKF Verified',
  Technical_Equivalent = 'Technical Equivalent',
  No_Secured_SKF_Alternative = 'No secured SKF Alternative'
}
